import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import './App.scss';
import { CustomerPortalInstancesProvider } from './Context/CustomerPortalInstancesContext';

function App() {
    return (
        <CustomerPortalInstancesProvider>
            <BrowserRouter>
                <Routes />
            </BrowserRouter>
        </CustomerPortalInstancesProvider>
    );
}

export default App;
